var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"main-container"},[_c('BaseHeader'),_c('Basebanner'),_c('main',{staticClass:"main_width"},[_c('router-view')],1)],1),_c('ContactForm'),_c('BaseFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }